import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import WithRender from  './zesa.html';
import { IZesa } from '@/Models/IZesa';
import config from '@/settings/config.js';
import { IZesaUserInfoAndPriceDto } from '@/Dtos/IZesaUserInfoAndPriceDto';
import { LocalStorageService } from '@/services/LocalStorageService';
import Modal from "@/components/Modal.vue";
import _axios from '@/services/axios';
import { PriceList, ProductRow } from '@/types/ProductTypes';
import { ProductData, ProductSettings } from '@/types/productSettingTypes';
import prdts from "@/settings/products";

@WithRender
@Component({
  components: {
    Loading,
    VuePhoneNumberInput,
    Modal
  }})

export default class Zesa extends Vue {
  zesaModel: IZesa = {} as IZesa;
  dto : IZesaUserInfoAndPriceDto = {} as IZesaUserInfoAndPriceDto;
  localStorageService: LocalStorageService;
  isLoading=false;
  fullPage= true;
  showNotification: boolean = false;
  notificationMessage: string ="";
  valideSenderNumberMessage:string ="";
  valideReceiverNumberMessage:string ="";
  senderNumber:string ="";
  receiverNumber:string ="";
  isSenderNumberValid: boolean = false;
  isReceiverNumberValid: boolean = false;
  AirTimeValues:any = {};
  priceList: PriceList = {} as PriceList;
  portfolio: string = "";
  selectedProduct = {} as ProductRow;
  productSetting: ProductSettings = prdts;
  product = {} as ProductData;
  
  constructor()
  {
    super();
    this.localStorageService = new LocalStorageService();
  }

  mounted () {
    this.product = this.productSetting.products.find(x => x.portiFolio == this.$route.query.portiFolio as string && x.isoCountry == this.$route.query.c as string) as ProductData;
    this.portfolio = this.product.portiFolio;
    this.getPriceList(this.portfolio);
   }

  ValidateSenderNumber(payload:any) {
    if (payload.isValid) {
      this.valideSenderNumberMessage = "";
      this.zesaModel.senderNumber = payload.countryCallingCode + payload.nationalNumber;
      this.isSenderNumberValid = true;
    } else {
      this.valideSenderNumberMessage = "Please make sure mobile number is valid!";
      this.isSenderNumberValid = false;
    }
  }

  private getPriceList(portiFolio: string) {
    this.isLoading = true;
    let dto =
    {
      portiFolio,
      originator: "za",
      parameters:null
    }
    this.$store.dispatch("product/GetPortiFolioOnlyProducts", dto)
    .then(value => {
     this.priceList = value as PriceList;
    })
    .catch(err => { console.error(err); })
    .finally(() => {
      this.isLoading = false;
    });
  }

  ValidateReceiverNumber(payload:any) {
    if (payload.isValid) {
      this.valideReceiverNumberMessage = "";
      this.zesaModel.recepientNumber = payload.countryCallingCode + payload.nationalNumber;
      this.isReceiverNumberValid = true;
    } else {
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
      this.isReceiverNumberValid = false;
    }
  }

  proceedToPayment():void
  {
    if(!this.isReceiverNumberValid || !this.isSenderNumberValid) return;
    
    this.isLoading=true;
    this.dto =
    { 
      meterNo : this.zesaModel.meterNumber,
      portiFolio : "zesa"
    }
 
  _axios.post(config.gateway + "payment/v2/Customer/zesa" ,this.dto).then(response=>
    {
      this.zesaModel.customerData = response.data;
      this.zesaModel.currency = this.product.isoSalesCurrency;
      this.zesaModel.salesCurrencyAmount = this.selectedProduct.salesCurrencyAmount;
      this.zesaModel.totalAmount = this.selectedProduct.totalAmount,
      this.zesaModel.key = this.priceList.key,
      this.localStorageService.add('zesa',JSON.stringify(this.zesaModel));
      this.$router.push("zesaCheckOut");
    }).catch((error) => {
      const err = error as any;
      if (err.response && err.response.status && err.response.status == '400')
        this.ErrorNotification(err.response.data, 'danger');
      else
        this.ErrorNotification("please check that you have data or your internet connection is on.", 'danger');
    })
    .finally(()=>this.isLoading=false);       
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}